/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMonatsauswertungenForAbteilung$Params {

/**
 * ID der Abteilung
 */
  abteilungId: string;

/**
 * Jahr für den die Auswertungen erstellt werden sollen
 */
  jahr: number;

/**
 * Monat für den die Auswertungen erstellt werden sollen
 */
  monat: number;

/**
 * ID des Layouts, dass verwendet werden soll
 */
  layoutId?: string;
}

export function getMonatsauswertungenForAbteilung(http: HttpClient, rootUrl: string, params: GetMonatsauswertungenForAbteilung$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getMonatsauswertungenForAbteilung.PATH, 'get');
  if (params) {
    rb.path('abteilungId', params.abteilungId, {});
    rb.path('jahr', params.jahr, {});
    rb.path('monat', params.monat, {});
    rb.query('layoutId', params.layoutId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getMonatsauswertungenForAbteilung.PATH = '/v1/auswertungen/abteilung/{abteilungId}/monatsauswertung/{jahr}/{monat}';
